 
$(".slick-arrow").click(function() {
  var attr = $(".slick-track .slick-current a").attr("data-image");
  console.log(attr);
});

// DROPDOWN See the format in cart page LSF
$('.dropdowns-menu label').on('click', function(){
    $(this).parents('.dropdowns').removeClass('open');
    var value = $(this).find('input').val();
    $('.dropdowns-menu label').not(this).parents('li').removeClass('active');
    $('.dropdowns-toggle .plc').text(value).addClass('bld');
    var target = $(this).attr('href');
    $('.tab-content .tab-pane').removeClass('active in');
    $(target).addClass('active in');
    console.log($(target));
});
$('.feature-filter .dropdowns-toggle').on('click', function(){
    $(this).parents('.feature-filter').toggleClass('open');
});


// FIX WARRANTY LINK IN PDP
var warrantPositon = $('#pt1 table').length;
if (warrantPositon >= 1) {
    $('#pt1 table:nth-child('+warrantPositon+')').find('a').attr('href', 'https://www.lsgfitness.com.au/pages/warranty');
}
